/**
 * The public form's two glyphs, in the navigation's own drawing (24 units, 1.7 stroke, round caps):
 * the builder („Twoja strona i formularz leadowy") and its inbox („Zgłoszenia").
 *
 * Moved out of `app/ui/NavIcons` on 28 September 2026, when each gained entry points below `app/`:
 * the builder's in the navigation, the inbox's head and `/raporty`'s lead-form card; the inbox's in
 * the roster's head. Decorative everywhere: every control that wears one carries its own name.
 */

interface IconProps {
  readonly className?: string;
}

const STROKE_PROPS = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.7,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
  focusable: false,
} as const;

/** The builder — a sheet with lines: the page and form a stranger fills in. */
export function PublicFormIcon({ className }: IconProps) {
  return (
    <svg className={className} {...STROKE_PROPS}>
      <rect x="5" y="3" width="14" height="18" rx="2" />
      <path d="M9 8h6M9 12h6M9 16h3" />
    </svg>
  );
}

/** „Zgłoszenia" — an inbox tray: what the form brought in. */
export function LeadsIcon({ className }: IconProps) {
  return (
    <svg className={className} {...STROKE_PROPS}>
      <path d="M4 13l2.5-7h11L20 13v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z" />
      <path d="M4 13h4.5l1 2h5l1-2H20" />
    </svg>
  );
}
